module.exports = __webpack_public_path__ + "img/bg_attend.b01a1417.png";